/**
 * PipelineProcess have information about the job process
 */

export interface PipelineProcess {
    id: number;
    /** path folder for job's output */
    input: string;
    /** represents a JSON with the job's input data */
    inputData: string;
    name: string;
    /** path folder for job's output */
    output: string;
    /** represents a JSON with the job's output data */
    outputData: string;
}
